var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4039",
    "data-name": "Path 4039",
    d: "M464.891,223.631a10,10,0,1,1,10-10A10.012,10.012,0,0,1,464.891,223.631Zm0-19.05a9.05,9.05,0,1,0,9.05,9.05A9.06,9.06,0,0,0,464.891,204.581Zm3.372,4.993a.74.74,0,1,0,.74.74A.74.74,0,0,0,468.263,209.574Zm-3.29.949a3.108,3.108,0,1,0,3.109,3.109A3.112,3.112,0,0,0,464.973,210.523Zm0,5.1a1.991,1.991,0,1,1,1.991-1.991A1.994,1.994,0,0,1,464.973,215.622Zm6.272-4.575a3.792,3.792,0,0,0-3.792-3.791h-5a3.792,3.792,0,0,0-3.791,3.791v5a3.792,3.792,0,0,0,3.791,3.791h5a3.792,3.792,0,0,0,3.792-3.791Zm-1.188,5a2.6,2.6,0,0,1-2.6,2.6h-5a2.6,2.6,0,0,1-2.6-2.6v-5a2.6,2.6,0,0,1,2.6-2.6h5a2.6,2.6,0,0,1,2.6,2.6Z",
    transform: "translate(-454.891 -203.631)",
    fill: "#006341"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramFooter);
export default __webpack_public_path__ + "static/media/instagram-footer.b69eb26ea350e3b8a5ddc9a6808905ef.svg";
export { ForwardRef as ReactComponent };